<script setup lang="ts">
import { useField } from 'vee-validate';
import { defineProps, withDefaults } from 'vue';

const props = withDefaults(
  defineProps<{
    name?: string;
    label: string;
    disabled?: boolean;
    trueValue?: any;
    falseValue?: any;
  }>(),
  { name: '' },
);

const emit = defineEmits(['change']);

const { value: value, errorMessage: errorMessage } = useField(props.name);
</script>

<template>
  <div>
    <q-toggle
      :label="props.label"
      v-model="value"
      :disable="disabled"
      v-bind="$attrs"
      :true-value="props.trueValue"
      :false-value="props.falseValue"
      @update:model-value="$emit('change')"
    />
  </div>
</template>
